"use client";

import Link from "next/link";
import "@/styles/page/_dao-tao-ngan-han.scss";

export interface TrainingCard {
  id: string;
  title: string;
  description: string;
  href: string;
  isExternal?: boolean;
}

export interface DaoTaoNganHanSectionProps {
  title?: string;
  subtitle?: string;
  cards?: TrainingCard[];
}

const DEFAULT_CARDS: TrainingCard[] = [
  {
    id: "nghiep-vu",
    title: "Nghiệp vũ - Kỹ năng",
    description: "Các khóa học kỹ năng chuyên môn ngắn hạn",
    href: "https://dtc.hub.edu.vn/",
    isExternal: true,
  },
  {
    id: "ngoai-ngu",
    title: "Ngoại ngữ - Tin học",
    description: "Các khóa học ngoại ngữ và tin học ngắn hạn",
    href: "https://flic.edu.vn/",
    isExternal: true,
  },
  {
    id: "chung-chi",
    title: "Chứng chỉ Ngắn hạn",
    description: "Các chương trình chứng chỉ ngắn hạn",
    href: "/dao-tao-ngan-han/chung-chi-ngan-han",
    isExternal: false,
  },
];

export function DaoTaoNganHanSection({
  title = "ĐÀO TẠO NGẮN HẠN",
  subtitle = "Các chương trình đào tạo ngắn hạn tại Trường Đại học Ngân hàng TP.HCM",
  cards = DEFAULT_CARDS,
}: DaoTaoNganHanSectionProps) {
  return (
    <section className="dao-tao-ngan-han">
      <div className="dao-tao-ngan-han__container">
        {/* Header */}
        <div className="dao-tao-ngan-han__header">
          <h1 className="dao-tao-ngan-han__title">{title}</h1>
          <p className="dao-tao-ngan-han__subtitle">{subtitle}</p>
        </div>

        {/* Cards Grid */}
        <div className="dao-tao-ngan-han__grid">
          {cards.map((card) => (
            <div key={card.id} className="dao-tao-ngan-han__card-wrapper">
              {card.isExternal ? (
                <a
                  href={card.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dao-tao-ngan-han__card"
                >
                  <CardContent title={card.title} description={card.description} />
                </a>
              ) : (
                <Link href={card.href} className="dao-tao-ngan-han__card">
                  <CardContent title={card.title} description={card.description} />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CardContent({ title, description }: { title: string; description: string }) {
  return (
    <>
      <div className="dao-tao-ngan-han__card-body">
        <h2 className="dao-tao-ngan-han__card-title">{title}</h2>
        <p className="dao-tao-ngan-han__card-description">{description}</p>
      </div>

      <div className="dao-tao-ngan-han__card-footer">
        <span className="dao-tao-ngan-han__card-link">Xem chi tiết</span>
        <svg
          className="dao-tao-ngan-han__card-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
          />
        </svg>
      </div>
    </>
  );
}

export default DaoTaoNganHanSection;

